import React from "react"

function IconBellRinging({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="bell-ringing"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-bell-ringing"
      {...props}
    >
      <path
        d="M6.89 2.466a2.012 2.012 0 0 1 2.673.973c.038.081.058.166.061.25a6.255 6.255 0 0 1 6.284 3.329l.118.24 1.276 2.736 1.99.724c.164.06.307.16.417.291l.075.104.063.113.798 1.712a.982.982 0 0 1-.366 1.246l-.109.059-4.638 2.163a3.533 3.533 0 0 1-6.39 2.979l-1.767.824a.982.982 0 0 1-1.245-.366l-.06-.109-.798-1.712a.982.982 0 0 1-.069-.626l.036-.124.723-1.99-1.275-2.737a6.258 6.258 0 0 1 1.382-7.2.618.618 0 0 1-.152-.205 2.011 2.011 0 0 1 .973-2.674zm7.451 14.496-4.007 1.868a2.224 2.224 0 0 0 4.007-1.869zM8.266 5.418a4.946 4.946 0 0 0-2.486 6.36l.094.213 1.505 3.228-.863 2.372.603 1.293 12.201-5.69-.602-1.292-2.374-.864-1.505-3.227a4.946 4.946 0 0 0-6.573-2.393zm-.823-1.765a.702.702 0 0 0-.377.836l.029.074.198-.116.204-.11.216-.105c.215-.1.432-.187.652-.261l.012.022a.703.703 0 0 0-.934-.34z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconBellRinging
